import React from 'react';
import { CommonTextProps } from 'components/atoms/text/types/Props';

export default function Subtitle({ text, styles }: CommonTextProps) {
  return <div className={`font-light text-sm sm:text-xl ${styles}`}>{text}</div>;
}
